import { render } from "./QuoteThin.vue?vue&type=template&id=d885eae0&scoped=true"
import script from "./QuoteThin.vue?vue&type=script&lang=js"
export * from "./QuoteThin.vue?vue&type=script&lang=js"

import "./QuoteThin.vue?vue&type=style&index=0&id=d885eae0&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d885eae0"]])

export default __exports__